module.exports = __webpack_public_path__ + "img/ediscovery_project_export.e3c3df83.svg";